import { Button, Form, Modal } from 'react-bootstrap'
import { SALESFORCE_URLS_BY_ENVIRONMENT } from '../../../common/common.entities'
import { Listing__c, PicklistValueInfo } from '../../utilities/listings.interfaces'
import { DateTime } from 'luxon'

interface ListingsInventoryModalProps {
  listings: Listing__c[]
  modalVisible: boolean
  closeModal: any
  title: string
  environment: string
  inventoryStatuses: PicklistValueInfo[]
  delistedReasons: PicklistValueInfo[]
}

export default function ProductListingsModal(props: ListingsInventoryModalProps){
  if(!props.listings) return <></>

  return <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
  <Modal.Header 
    closeButton
    style={{ 
      position: 'sticky', 
      top: -1, 
      zIndex: 1050, 
      backgroundColor: 'white', 
      borderBottom: '1px solid #ddd'
    }}
  >
    <Modal.Title>
      <span className='beacon-header'>{props.title}</span>
    </Modal.Title>
  </Modal.Header>
    
  <Modal.Body>
    <div style={{fontSize: 'larger'}}>  
      <table className='flexport-table'>
        <thead className='sticky-row-2'>
          <tr>
            <th>
              <span className='beacon-header'>INTEGRATION</span>
            </th>
            <th>
              <span className='beacon-header'>NAME</span>
            </th>
            <th>
              <span className='beacon-header'>SKU</span>
            </th>
            <th>
              <span className='beacon-header'>MP ENABLED</span>
            </th>
            <th>
              <span className='beacon-header'>INVENTORY STATUS</span>
            </th>
            <th>
              <span className='beacon-header'>DELISTED REASON</span>
            </th>
            <th>
              <span className='beacon-header'>COSTS</span>
            </th>
            <th>
              <span className='beacon-header'>ACTIONS</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.listings.map((listing, index) => (
            <tr>
              {/* LISTING CELLS */}
              <td style={{fontSize: '10px'}}>
                <span title='Opens the Integration in Mission Control.'>
                  <a href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${listing.Integration__c}`} className='beacon-link' target="_blank" rel="noopener noreferrer">
                    {listing.Integration__r.Name}
                  </a>
                </span>
              </td>
              <td>
                <span title='Opens the Listing in Mission Control.'>
                  <a href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${listing.Id}`} className='beacon-link' target="_blank" rel="noopener noreferrer">
                    {listing.Name}
                  </a>
                </span>
              </td>
              <td>
                <Form.Control 
                  type='text'
                  value={listing.SKU__c}  
                />
              </td>
              <td>
                <Form.Check 
                  onChange={undefined}
                  id={`mp-enabled-${listing.Id}`} 
                  title={`${listing.SKU__c} is marketplace ${listing.Enable__c === true ? 'enabled.' : 'disabled.'}`}
                  checked={listing.Enable__c === true}
                />
              </td>
              <td>
                <Form.Select disabled={listing.Name.includes('-FBA_')} id={`inventory-status-${listing.Id}`} style={{width: '150px'}}>
                  <option id={`inventory-status-none-${listing.Id}`} selected={!listing.Inventory_Status__c}>-- NONE --</option>
                  {props.inventoryStatuses.map((is) => (
                    <option id={`inventory-status-${is.Value}-${listing.Id}`} selected={listing.Inventory_Status__c === is.Label} value={is.Value}>{is.Label}</option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <Form.Select key={`delisted-reason-${listing.Id}`} id={`delisted-reason-${listing.Id}`} style={{width: '250px'}}>
                  <option id={`delisted-reason-none-${listing.Id}`} selected={!listing.Delisted_Reason__c}>-- NONE --</option>
                  {props.delistedReasons.map((dr) => (
                    <option key={`delisted-reason-${dr.Value}-${listing.Id}`} id={`delisted-reason-${dr.Value}-${listing.Id}`} selected={listing.Delisted_Reason__c === dr.Label} value={dr.Value}>{dr.Label}</option>
                  ))}
                </Form.Select>
              </td>
              <td>
                {listing.Marketplace_Cost__c ? `$${listing.Marketplace_Cost__c}` : 'N/A'} / {listing.Promo_Marketplace_Cost__c ? `$${listing.Promo_Marketplace_Cost__c}` : 'N/A'}
              </td>
              <td>
                <Button variant='secondary'>MP DISABLE</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant='secondary' onClick={props.closeModal}>CLOSE</Button>
  </Modal.Footer>
</Modal>
}